/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {LegalEntityRegionDTO} from '../model/LegalEntityRegionDTO';
import {RestBodyResponseUtil} from '../model/RestBodyResponseUtil';

/**
* LegalEntityRegionService service.
* @module api/LegalEntityRegionServiceApi
* @version v0
*/
export class LegalEntityRegionServiceApi {

    /**
    * Constructs a new LegalEntityRegionServiceApi. 
    * @alias module:api/LegalEntityRegionServiceApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the getAllLegalEntityRegions operation.
     * @callback moduleapi/LegalEntityRegionServiceApi~getAllLegalEntityRegionsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/LegalEntityRegionDTO>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get list of all the Legal Entity Regions
     * Request to get a list of all the Legal Entity Regions
     * @param {module:api/LegalEntityRegionServiceApi~getAllLegalEntityRegionsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    getAllLegalEntityRegions(callback) {
      
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [LegalEntityRegionDTO];

      return this.apiClient.callApi(
        '/api/legal-entity-region', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}